import { Event } from './event';

export class StudentImpactVideoDisplayedEvent extends Event<void> {}
